<script>
	import { afterNavigate, beforeNavigate, goto, invalidateAll } from '$app/navigation';
	import { appUserRole } from '$lib/constants';
	import { confirm, edited, message, disableBtns } from '$lib/stores';
	import '../app.css';
	import { setContext } from 'svelte';
	import { _, isLoading } from 'svelte-i18n';
	import Message from '$lib/elements/message.svelte';
	import Confirm from '$lib/elements/confirm.svelte';
	import { me } from '$lib/MeService';

	export let data;
	setContext('directus', data.directus);
	setContext('auth', data.auth);
	setContext('services', data.services);

	let navigationToggle = false;

	beforeNavigate(async ({ cancel, to, type }) => {
		/* to will be null for reload/unload events */
		$disableBtns = true;
		if (to !== null) {
			if (to.url.searchParams.has('go')) {
				to.url.searchParams.delete('go');
				return;
				/* prevents infinite loop */
			}
		}
		if ($edited) {
			cancel();
			if (to !== null) {
				let app = $me && $me.role === appUserRole;

				$confirm = {
					active: true,
					text: app ? $_('app.leaveMsg') : $_('general.leaveMsg'),
					okText: app ? $_('app.yes') : $_('general.confirmOk'),
					cancelText: app ? $_('app.no') : $_('general.confirmCancel'),
					app: app ? true : false,
					action: () => {
						to.url.searchParams.set('go', '');
						goto(to.url.href, { replaceState: type === 'popstate', invalidateAll: true });
					}
				};
			}
		}
	});

	afterNavigate(({ from, to }) => {
		$disableBtns = false;
		$edited = false;
		/* For admin, check if same link was clicked again (navigated to same page),
		and reload page with key. */
		if ($me && $me.role !== appUserRole && from !== null && to !== null) {
			if (from.url?.toString() === to.url?.toString()) {
				invalidateAll();
				navigationToggle = !navigationToggle;
			}
		}
	});
</script>

{#if $message.active}
	<Message />
{/if}

{#if $confirm.active}
	<Confirm />
{/if}

{#if $isLoading}
	<p>Loading...</p>
{:else}
	{#key navigationToggle}
		<slot />
	{/key}
{/if}
